
document.addEventListener('lazyloaded', (e) => {
  let placeholder = e.target.closest('.image-placeholder');
  if (placeholder) {
    placeholder.classList.add('has-image');
  }
});
